export type { ShopPageProps } from "./shop-page";
export { ShopPage } from "./shop-page";
